/**
 * API 계약 — 명세서 §11
 * 응답 포맷 `{ data, meta }` / `{ error: { code, message } }` 통일.
 */
export const API_PREFIX = '/api/v1';
export function isApiError(response) {
    return typeof response === 'object' && response !== null && 'error' in response;
}
/** 도메인 오류 코드 — 클라이언트 분기용 */
export const ERROR_CODES = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    CONFLICT: 'CONFLICT',
    /** 구독 게이트 차단 (§4) */
    SUBSCRIPTION_READ_ONLY: 'SUBSCRIPTION_READ_ONLY',
    /** 시설 스코프 위반 */
    FACILITY_SCOPE_VIOLATION: 'FACILITY_SCOPE_VIOLATION',
    /** 보호자–원아 연결 검증 실패 (§9.1) */
    GUARDIANSHIP_REQUIRED: 'GUARDIANSHIP_REQUIRED',
    PHONE_NOT_VERIFIED: 'PHONE_NOT_VERIFIED',
    OTP_INVALID: 'OTP_INVALID',
    OTP_EXPIRED: 'OTP_EXPIRED',
    INVITE_INVALID: 'INVITE_INVALID',
    INVITE_EXPIRED: 'INVITE_EXPIRED',
    RATE_LIMITED: 'RATE_LIMITED',
    AI_QUOTA_EXCEEDED: 'AI_QUOTA_EXCEEDED',
    INTERNAL: 'INTERNAL',
};
/** JWT 수명 (§5.1) */
export const TOKEN_TTL = {
    accessMinutes: 30,
    refreshDays: 14,
};
//# sourceMappingURL=api.js.map